import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: '智能客服' },
    created_at: 1736033561,
    description: '通过自动化工作流程和即时回复，提升客户服务效率。',
    id: 4,
    name: '客服助手',
  },
  {
    account_id: 3,
    config: { product_name: '客户管理工具' },
    created_at: 1736033562,
    description: '整理联系人、自动跟进并提供分析，帮助管理客户关系。',
    id: 5,
    name: '客户管理助手',
  },
  {
    account_id: 4,
    config: { product_name: '销售流程' },
    created_at: 1736033563,
    description: '跟踪潜在客户、预测销售并自动处理日常任务。',
    id: 6,
    name: '销售助手',
  },
  {
    account_id: 5,
    config: { product_name: '工单智能助手' },
    created_at: 1736033564,
    description: '自动分配和分类工单，并回复客户常见问题。',
    id: 7,
    name: '工单助手',
  },
  {
    account_id: 6,
    config: { product_name: '财务助手' },
    created_at: 1736033565,
    description: '提供财务分析和报表，帮助团队依据数据作出决策。',
    id: 8,
    name: '财务分析助手',
  },
  {
    account_id: 8,
    config: { product_name: '人事助手' },
    created_at: 1736033567,
    description: '简化员工管理、薪酬和招聘等人事工作。',
    id: 10,
    name: '人事管理助手',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: '客服助手' },
    content: '介绍如何使用会话筛选器高效管理客户会话。',
    created_at: 1736143272,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688192-how-to-use-conversation-filters',
    id: 3059,
    name: '如何使用会话筛选器',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: '客服助手' },
    content: '分步介绍如何自动分配工单并优化客服工作流程。',
    created_at: 1736143273,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688200-automating-ticket-assignments',
    id: 3060,
    name: '自动分配工单',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: '客户管理助手' },
    content: '详细介绍如何管理和整理客户资料。',
    created_at: 1736143274,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688210-managing-customer-profiles',
    id: 3061,
    name: '管理客户资料',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: '销售助手' },
    content: '了解如何优化销售跟踪并改进销售预测。',
    created_at: 1736143275,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688220-sales-tracking-guide',
    id: 3062,
    name: '销售跟踪指南',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: '工单助手' },
    content: '介绍如何高效创建、管理和解决工单。',
    created_at: 1736143276,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688230-managing-tickets',
    id: 3063,
    name: '管理工单',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: '财务分析助手' },
    content: '详细介绍如何使用财务报表工具并生成分析结果。',
    created_at: 1736143277,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688240-financial-reporting',
    id: 3064,
    name: '财务报表指南',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer: '消息渠道可能因套餐限制或收件箱数量达到上限而停用。',
    created_at: 1736283330,
    id: 87,
    question: '为什么消息渠道被停用了？',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033280,
      description: '处理常见咨询和系统问题。',
      id: 1,
      name: '客服助手二',
    },
  },
  {
    account_id: 2,
    answer: '进入“集成”页面并选择 WhatsApp，即可关联您的 WhatsApp 账户。',
    created_at: 1736283340,
    id: 88,
    question: '如何关联 WhatsApp？',
    assistant: {
      account_id: 2,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033281,
      description: '处理集成和配置相关问题。',
      id: 2,
      name: '客服助手三',
    },
  },
  {
    account_id: 3,
    answer: '请在登录页点击“忘记密码”，然后按照邮件中的说明完成重置。',
    created_at: 1736283350,
    id: 89,
    question: '如何重置密码？',
    assistant: {
      account_id: 3,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033282,
      description: '处理账户管理和账户找回问题。',
      id: 3,
      name: '客服助手四',
    },
  },
  {
    account_id: 4,
    answer: '进入设置中的“外观”，选择“深色模式”即可启用。',
    created_at: 1736283360,
    id: 90,
    question: '如何启用深色模式？',
    assistant: {
      account_id: 4,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033283,
      description: '处理界面和主题相关问题。',
      id: 4,
      name: '客服助手五',
    },
  },
  {
    account_id: 5,
    answer: '进入“设置”中的“团队”，点击“添加团队成员”即可。',
    created_at: 1736283370,
    id: 91,
    question: '如何添加团队成员？',
    assistant: {
      account_id: 5,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033284,
      description: '处理团队管理和用户权限相关问题。',
      id: 5,
      name: '客服助手六',
    },
  },
  {
    account_id: 6,
    answer: '活动可向指定客户群体发送消息，您可以在“活动”页面创建。',
    created_at: 1736283380,
    id: 92,
    question: '什么是活动？',
    assistant: {
      account_id: 6,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033285,
      description: '处理营销、活动管理和消息策略相关问题。',
      id: 6,
      name: '客服助手七',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: '邮件客服',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: '网站在线客服',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook 客服',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: '短信服务',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp 客服',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Telegram 客服',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE 客服',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API 渠道',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: '基础短信',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];
